module.exports = __webpack_public_path__ + "static/media/thesis.8bbea2e3.pdf";